"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTickStatusUpdate = void 0;
var _reactRedux = require("react-redux");
var _react = require("react");
var _devices = require("../../../entities/devices");
var _constants = require("../../../utils/constants");
var _sites = require("../../../entities/sites");
const useTickStatusUpdate = () => {
  const dispatch = (0, _reactRedux.useDispatch)();
  const interval = (0, _react.useRef)(null);
  const activeSiteId = (0, _reactRedux.useSelector)(_sites.selectActiveSiteId);
  (0, _react.useEffect)(() => {
    const makeIntervalStatusUpdate = () => {
      if (!activeSiteId) return;
      clearInterval(interval.current);
      interval.current = setInterval(() => dispatch((0, _devices.updateTemperatureStatusesAction)()), _constants.secondsAmountInOneMinute * _constants.millisecondsAmountInOneSecond);
    };
    makeIntervalStatusUpdate();
    return () => {
      clearInterval(interval.current);
    };
  }, [dispatch, activeSiteId]);
};
exports.useTickStatusUpdate = useTickStatusUpdate;